import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function ObjectionsBlock() {
  const objections = [{
    q: '"¿Y si no sé usar la IA?"',
    a: 'No necesitas experiencia. La guía incluye un capítulo de inicio rápido y los prompts están listos para copiar y pegar.'
  }, {
    q: '"¿Tengo que pagar por ChatGPT Plus?"',
    a: 'No. Todos los prompts están diseñados para funcionar perfectamente con la versión gratuita.'
  }, {
    q: '"¿Y si no me sirve?"',
    a: 'Tienes 30 días de garantía extendida por comprar ahora. Si no ves resultados, te devolvemos tu dinero sin preguntas.'
  }, {
    q: '"¿En qué formato viene?"',
    a: 'Recibes un PDF interactivo de 60 páginas y el audiolibro completo. Puedes descargar ambos inmediatamente después del pago.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleObjection = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{
    once: true
  }} className="max-w-3xl mx-auto" data-id="element-74">
      <h2 className="text-3xl max-sm:text-2xl font-serif font-bold text-[#E8E0D0] mb-8 max-sm:mb-5 text-center" data-id="element-75">
        Respuestas a tus dudas
      </h2>
      <div className="space-y-4 max-sm:space-y-3" data-id="element-76">
        {objections.map((obj, i) => {
        const isOpen = openIndex === i;
        return <div key={i} className="bg-[#111111] border border-[#D4AF37]/20 rounded-xl overflow-hidden shadow-[0_0_15px_rgba(0,0,0,0.5)]" data-id="element-77">
              <button onClick={() => toggleObjection(i)} aria-expanded={isOpen} className="w-full px-6 max-sm:px-4 py-5 max-sm:py-4 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37]" data-id="element-78">
                <span className="text-lg max-sm:text-base font-bold text-[#D4AF37] pr-4" data-id="element-79">
                  {obj.q}
                </span>
                <motion.div animate={{
              rotate: isOpen ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="shrink-0" data-id="element-80">
                  <ChevronDownIcon className="w-6 h-6 max-sm:w-5 max-sm:h-5 text-[#D4AF37]" data-id="element-81" />
                </motion.div>
              </button>

              <AnimatePresence initial={false} data-id="element-82">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-83">
                    <div className="px-6 max-sm:px-4 pb-5 max-sm:pb-4 text-[#A09880] leading-relaxed max-sm:text-sm" data-id="element-84">
                      {obj.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </motion.div>;
}